import {
  createContext,
  useContext,
  useState,
  useEffect,
  type ReactNode,
} from "react"

interface PassphraseContextType {
  hasPassphrase: boolean
  setHasPassphrase: (has: boolean) => void
  checkPassphrase: () => boolean
  externalFlowActive: boolean
  setExternalFlowActive: (active: boolean) => void
}

const PassphraseContext = createContext<PassphraseContextType | undefined>(
  undefined,
)

const STORAGE_KEY = "passhprase"

export function PassphraseProvider({ children }: { children: ReactNode }) {
  const [hasPassphrase, setHasPassphrase] = useState<boolean>(false)
  const [externalFlowActive, setExternalFlowActive] = useState<boolean>(false)

  const checkPassphrase = (): boolean => {
    const existing =
      localStorage.getItem(STORAGE_KEY) ||
      localStorage.getItem("user-passphrase")
    const exists = !!existing
    setHasPassphrase(exists)
    return exists
  }

  useEffect(() => {
    // Check passphrase on app startup
    checkPassphrase()
  }, [])

  return (
    <PassphraseContext.Provider
      value={{
        hasPassphrase,
        setHasPassphrase,
        checkPassphrase,
        externalFlowActive,
        setExternalFlowActive,
      }}
    >
      {children}
    </PassphraseContext.Provider>
  )
}

export function usePassphrase() {
  const context = useContext(PassphraseContext)
  if (context === undefined) {
    throw new Error("usePassphrase must be used within a PassphraseProvider")
  }
  return context
}
